import React from 'react';
import { Link } from 'react-router-dom'
import { withStyles } from 'tss-react/mui';
import Button from '@mui/material/Button';
import { Container, Typography, Box } from '@mui/material';
import { history } from './services/history'
import LogoUnicamp from './logos/logo_unicamp.png'


const useStyles = (theme, props) => ({
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    button: {
        margin: theme.spacing(3),
        /*width: '100%',*/
    },
})

class Home extends React.Component {

    render() {
        const { classes } = this.props;
        if (this.props.userData){
            if (this.props.userData.is_superuser)
                history.push("/Admin")
            else if (this.props.userData.is_staff)
                history.push("/Funcionario")
            else history.push("/Familia")
        }
        else
        return (
            <Container >
                <Box className={classes.paper}>
                    <Box sx={{marginCenter:"75px"}}><img src={LogoUnicamp} width="150px" height="75px" alt="" /></Box>
                    <Typography variant="h5"><center>Serviço de Referência em Triagem Neonatal - SRTN/Unicamp</center></Typography>
                    <br></br>
                    <Link style={{ textDecoration: 'none', color: 'white' }} to="/LoginFamiliaGovBr"><Button color="primary" variant="contained" className={classes.button}>Família</Button></Link> 
                    <Link style={{ textDecoration: 'none', color: 'white' }} to="/LoginFuncionario"><Button color="primary" variant="contained" className={classes.button}>Instituição</Button></Link>

                </Box>
            </Container>);
    }
}
export default withStyles(Home, useStyles);
